const isEmptyObject = (obj: Record<string, string>) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export default isEmptyObject;
